import Alpine from 'alpinejs'
// import intersect from '@alpinejs/intersect'
// import collapse from '@alpinejs/collapse'
import './copy'
import './detect_cloudflare'
import './direct_upload_image'
import './direct_upload_files'
import './auto_fill_email'
import './auto_submit_form'
import './detect_fontsize_and_smallize'
import './admin/form/copy_html'

// Alpine.plugin(intersect)
// Alpine.plugin(collapse)

window.Alpine = Alpine

Alpine.start()

// TODO: 暫時關掉，因為turbo_frame裡面link取代後，會導致x_dataStack會被清空
// NOTICE: `上一頁`, `下一頁`後的aplinejs不會因為turbo出現問題
// document.addEventListener('turbo:before-cache', () => {
//   document.querySelectorAll('[x-data]').forEach(dom => {
//     Alpine.destroyTree(dom)
//   })
// })
